import Vue from 'vue';
import Auth from '@/Auth';
import Main from '@/Main';
import Plan from '@/Plan';
import Callback from '@/Callback';
import Admin from '@/Admin';
import store from './store';
import Invoice from '@/Invoice';
import Campaign from '@/Campaign';
import VueRouter from 'vue-router';
import AuthLogin from '@/Auth/Login';
import AuthReset from '@/Auth/Reset';
import Overview from '@/Campaign/Overview';
import AuthPassword from '@/Auth/Password';
import AuthRegister from '@/Auth/Register';
import CampaignShow from '@/Campaign/Show';
import CampaignForm from '@/Campaign/Form';
import InvoicePaypal from '@/Invoice/Paypal';

Vue.use(VueRouter);

const checkAuth = guest => (to, from, next) => {
  store.dispatch('auth/check')
    .then((user) => guest ? '/' : false)
    .catch(() => guest ? false : '/auth/login')
    .then(path => path ? next({ path }) : next());
};

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/auth/',
      redirect: 'login',
      meta: {
        guest: true,
      },
      beforeEnter: checkAuth(true),
      component: Auth, // has <router-view /> inside
      children: [
        {
          name: 'Login',
          path: 'login',
          component: AuthLogin,
        },
        {
          path: 'register',
          name: 'register',
          component: AuthRegister,
        },
        {
          name: 'reset',
          path: 'reset',
          component: AuthReset,
        },
        {
          name: 'reset',
          path: 'reset/:token',
          component: AuthPassword,
          props: true,
        },
      ],
    },
    {
      path: '/',
      redirect: 'reports',
      beforeEnter: checkAuth(false),
      component: Main, // has <router-view /> inside
      children: [
        {
          path: 'overview',
          name: 'overview',
          component: Overview,
        },
        {
          path: 'reports',
          name: 'reports',
          component: Campaign,
        },
        {
          path: 'auth/logout',
          beforeEnter (to, from, next) {
            store.dispatch('auth/logout')
              .then(() => window.location.reload());
          },
        },
        {
          path: 'campaign/new',
          name: 'campaign_create',
          component: CampaignForm,
        },
        {
          path: 'campaign/:hash_id',
          name: 'campaign_show',
          component: CampaignShow,
          props: true,
        },
        {
          path: 'campaign/:hash_id/edit',
          name: 'campaign_show',
          component: CampaignForm,
          props: true,
        },
        {
          path: 'plan',
          name: 'plan',
          component: Plan,
        },
        {
          path: 'callback',
          name: 'callback',
          component: Callback,
        },
        {
          path: 'invoice',
          name: 'invoice',
          component: Invoice,
        },
        {
          path: 'invoice/:invoice/paypal',
          name: 'invoice_paypal',
          component: InvoicePaypal,
          props: true,
        },
        {
          path: 'admin',
          name: 'admin',
          component: Admin,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/core/router.js